export const isLocalStorageSupported: boolean = (() => {
  const storage = window.localStorage;
  try {
    storage.setItem('test', 'passed');
    storage.removeItem('test');
    return true;
  } catch (error) {
    return false;
  }
})();

export function setCookie(name: string, value: any, expires: Date, path: string) {
  document.cookie = `
    ${name}=${encodeURI(value)}
    ${expires ? `; expires=${expires}` : ''}
    ${(path) ? `; path=${path}` : ''}
    `.replace(/\n/g, '');
}

export function getCookie(name: string) {
  const cookie = document.cookie;
  const prefix = `${name}=`;
  let begin = cookie.indexOf(`; ${prefix}`);

  if (begin === -1) {
    begin = cookie.indexOf(prefix);
    if (begin !== 0) {
      return null;
    }
  } else {
    begin += 2;
  }

  let end = document.cookie.indexOf(';', begin);

  if (end === -1) {
    end = cookie.length;
  }

  return decodeURI(cookie.substring(begin + prefix.length, end));
}

export function deleteCookie(name: string, path: string) {
  if (getCookie(name)) {
    const expires = new Date();
    expires.setDate(expires.getDate() - 1);

    setCookie(name, '', expires, path);
  }
}
